const INITIAL_STATE = {
  // todoList is what needs to be past to the different pages that need to access it
  todoList: [],
  // todoId: 1,
  currentTodo: null,
  currentTodoName: "Editable Todo Name",
  currentPomodoroNumber: 0,
  todoFinished: 0,
  pomodoroFinished: 0,
  pomodoroTime: 25,
  shortRestTime: 5,
  longRestTime: 15,
  currentDate: new Date(),
  endTime: null,
  todoNote: "",
}

const todos = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // case "INCREASE_TODO_ID":
    //   return {
    //     ...state,
    //     todoId: state.todoId + 1,
    //   }
    // case "SET_TODO_ID":
    //   return {
    //     ...state,
    //     todoId: action.id,
    //   }
    case "INCREASE_TODO_COUNT":
      return {
        ...state,
        todoFinished: state.todoFinished + 1,
      }
    case "SET_POMODORO_NUMBER":
      return {
        ...state,
        currentPomodoroNumber: action.number,
      }
    case "SET_TIMER":
      switch (action.timerType) {
        case "short":
          return {
            ...state,
            shortRestTime: action.minutes,
          }
        case "long":
          return {
            ...state,
            longRestTime: action.minutes,
          }
        default:
          return {
            ...state,
            pomodoroTime: action.minutes,
          }
      }

    case "SET_CURRENT_DATE":
      return {
        ...state,
        currentDate: new Date(),
      }
    case "SET_END_TIME":
      return {
        ...state,
        endTime: action.time,
      }
    case "SET_TODO_NOTE":
      return {
        ...state,
        todoNote: action.noteText,
      }
    case "ADD_TODO":
      var updatedTodoList = [...state.todoList, todo(undefined, action)]
      localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

      return {
        // add the todo to the todoList
        // then update the todoList in the state
        ...state,
        // todoId: state.todoId + 1,
        todoList: updatedTodoList,
      }
    case "DELETE_TODO":
      var updatedTodoList = state.todoList.filter(todo => {
        return todo.id !== action.id
      })
      localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

      return {
        ...state,
        todoList: updatedTodoList,
      }
    case "UPDATE_TODO":
      var updatedTodo = todo(undefined, action)
      var updatedTodoList = state.todoList.map(todo => {
        return todo.id === action.id ? updatedTodo : todo
      })
      localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

      return {
        ...state,
        todoList: updatedTodoList,
      }
    case "UPDATE_ALL_TODOS":
      // this need to return the state, which has the todoList
      var updatedTodoList = action.todos
      localStorage.setItem("todoList", JSON.stringify(updatedTodoList))

      return {
        ...state,
        todoList: updatedTodoList,
      }
    case "COMPLETE_TODO":
      return {
        ...state,
        // this is equivalent to setState()
        todoList: state.todoList.map(todo => {
          if (todo.id === action.id) {
            updatedTodo = todo
            updatedTodo.completed = !updatedTodo.completed
            updatedTodo.startTime = action.startTime
            updatedTodo.completionTime = action.completionTime
            updatedTodo.plannedMinutes = action.plannedMinutes
            return updatedTodo
          }

          return todo
        }),
      }
    case "TOGGLE_TODO":
      return { ...state, todoList: state.todoList.map(t => todo(t, action)) }
    default:
      return state
  }
}

const todo = (state, action) => {
  switch (action.type) {
    case "ADD_TODO":
      // returns the todo object
      return {
        id: Date.now(),
        text: action.todo.text,
        completed:
          typeof action.todo.completed === "undefined"
            ? false
            : action.todo.completed,
        plannedMinutes:
          typeof action.todo.plannedMinutes === "undefined"
            ? null
            : action.todo.plannedMinutes,
        creationTime: new Date(),
        startTime:
          typeof action.todo.startTime === "undefined"
            ? null
            : action.todo.startTime,
        completionTime:
          typeof action.todo.completionTime === "undefined"
            ? null
            : action.todo.completionTime,
        todoType:
          typeof action.todo.todoType === "undefined"
            ? null
            : action.todo.todoType,
      }
    case "UPDATE_TODO":
      return {
        id: action.updatedTodo.id,
        text: action.updatedTodo.text,
        completed:
          typeof action.updatedTodo.completed === "undefined"
            ? false
            : action.updatedTodo.completed,
        plannedMinutes:
          typeof action.updatedTodo.plannedMinutes === "undefined"
            ? null
            : action.updatedTodo.plannedMinutes,
        creationTime:
          typeof action.updatedTodo.creationTime === "undefined"
            ? null
            : action.updatedTodo.creationTime,
        startTime:
          typeof action.updatedTodo.startTime === "undefined"
            ? null
            : action.updatedTodo.startTime,
        completionTime:
          typeof action.updatedTodo.completionTime === "undefined"
            ? null
            : action.updatedTodo.completionTime,
        todoType:
          typeof action.updatedTodo.todoType === "undefined"
            ? null
            : action.updatedTodo.todoType,
      }
    case "TOGGLE_TODO":
      if (state.id !== action.id) {
        return state
      }

      return {
        ...state,
        completed: !state.completed,
      }
    default:
      return state
  }
}

export default todos
